import {User} from "@/models/user.model";

export function getDifferenceBetweenArraysOfUsers(a: User[], b: User[]): User[] {
    return a.filter((user) => {
        return !b.map(bUser => bUser.userID).includes(user.userID);
    });
}
